export default {
    id: 0,
    enabled: false,
    img_web: false,
    img_mobile: false,
    content: {
        ka: '',
        en: ''
    }
}